// plugins 
import {gmapApi} from 'vue2-google-maps'

// helper
import Helper from '@/helpers/helper'

export const mapMixins = {
    data() {
        return {
            mapOptions   : {
                zoomControl      : false,
                mapTypeControl   : false,
                scaleControl     : false,
                streetViewControl: false,
                rotateControl    : false,
                fullscreenControl: false,
                disableDefaultUi : true,
            },
            pingLatLng : {
                lat: 40.23797766073543,
                lng: -111.66745272906115
            },
            svgMarker : null
        }
    },
    computed: {
        google: gmapApi
    },
    methods : {
        /**
         * Autocomplete address with dropdown suggestion
         * @param {DOM} element 
         * @param {Function} callback
         */
         autocompletedress(element, callback) {
            if(this.google) {
                console.log('google map autocomplete inititated');

                const bound = new this.google.maps.LatLngBounds(
                    new this.google.maps.LatLng(40.76072578643754, -111.89679763140082),
                );
                

                const options = {
                    bounds               : bound,
                    componentRestrictions: { country: "us" },
                    fields               : ["address_components", "geometry", "icon", "name"],
                    strictBounds         : false,
                    radius               : 20000
                };
                  
                let service = new this.google.maps.places.Autocomplete(element, options);

                service.addListener('place_changed', () => {
                    const place = service.getPlace();
                    if(callback && typeof callback == 'function') {
                        callback(place)
                    }
                });

            }
        },
       /**
        * Search places from google map api
        * @param {DOM} element 
        * @param {String} querystring 
        */
        async queryPlace(element, querystring = '') {
            if(this.google) {
                let service = new this.google.maps.places.PlacesService(element);

                const newpromise = new Promise((resolve) => {

                    let search_query = {
                        fields : ['formatted_address', 'geometry', 'place_id', 'types'],
                        query : querystring
                    };
    
                    service.findPlaceFromQuery(search_query, res => {
                        resolve(res);
                    })
                });

                return newpromise;

            }
        },
        /**
         * Open map
         * @param {*} type 
         * @param {*} order 
         */
        openMap(type ='point', order) {

            const isDesktop = window.innerWidth > 1360 ? true : false;
            const lat       = parseFloat(order.shipping_address_latitude)
            const lng       = parseFloat(order.shipping_address_longitude)

            console.log('testing helper', Helper.getdevicetype('device'))

            if(type == 'drive') {

                
                if(isDesktop) {
                    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}+${order.shipping_address_street}&travelmode=driving`
                    window.open(encodeURI(url));
                } else {
                    /**
                     * Check device if iOS or Andriod
                     */
                    if(Helper.getdevicetype('device') == 'iOS') {
                        console.log(`maps://?q=${lat},${lng}`)
                        window.location.href = `maps://?q=${lat},${lng}`
                        // window.location = `google.navigation:q=${lat},${lng}&mode=d`
                    } else {
                        window.location = `google.navigation:q=${lat},${lng}&mode=d`
                    }
                }
            } else {
                if(isDesktop) {
                    const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}+${order.shipping_address_street}`
                    window.open(encodeURI(url));
                } else {
                    window.location = `geo:${lat},${lng}?q=${order.shipping_address_stree}`
                }
            }
            // window.location =  'https://www.google.com/maps/dir/?api=1&destination=14.625094215984506,121.05768642828393&mode=d'
        },
        initMap() {
            if(this.google) {
                this.$nextTick(() => {
                    this.svgMarker = {
                        path        : "M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
                        fillColor   : "#A32035",
                        fillOpacity : 1,
                        strokeWeight: 0,
                        rotation    : 0,
                        scale       : 1.5,
                        anchor      : new this.google.maps.Point(0, 10),
                    }
                });
            } 
        }
    }
}